export type DashboardDisplayProfile = {
    displayName?: string | null;
    email?: string | null;
};

export type DashboardDisplaySettings = {
    displayName?: string | null;
};

export const getEmailPrefix = (email?: string | null) => {
    const prefix = (email || '').split('@')[0]?.trim();
    return prefix || '';
};

export const getDashboardDisplayName = (
    profile: DashboardDisplayProfile | null,
    settings?: DashboardDisplaySettings | null
) => {
    const settingsDisplayName = settings?.displayName?.trim();
    const firebaseDisplayName = profile?.displayName?.trim();
    return settingsDisplayName || firebaseDisplayName || getEmailPrefix(profile?.email) || 'Investor';
};
